const getters = {
    getMyFunction: (state, getters, rootState, rootGetters) => {
        const userData = _.find(_.toArray(state.userData), {id: `${rootGetters['users/getMeBasic'].userId}`});
        return userData ? userData.function : 'unknown';
    },
    getPageVisibility: (state, getters) => (page) => {
        if (page === 'cycle-count') {
            const myFunction = getters.getMyFunction;
            const visibleFor = ['root', 'Teamleider', 'Assistent Teamleider'];
            return visibleFor.indexOf(myFunction) > -1;
        } else {
            return true;
        }
    }
}

export default getters